import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Button } from 'reactstrap';

const AdminModal = ({
  modalOpen,
  closeModal,
  action,
  title,
  currentItem,
  editFields,
  handleModalSave,
  formatField,
  setCurrentItem }) => {

  const handleInputChange = (field, value) => {
    setCurrentItem(prevItem => ({
      ...prevItem,
      [field]: value
    }));
  };

  return (
    <Modal isOpen={modalOpen} toggle={closeModal}>
      <ModalHeader toggle={closeModal}>
        {action === 'edit' && `Edit ${title}`}
        {action === 'add' && `Add New ${title}`}
        {action === 'delete' && `Delete ${title}`}
      </ModalHeader>
      <ModalBody>
        {(action === 'edit' || action === 'add') && (
          <div className="form-group">
            {editFields.map(field => (
              <React.Fragment key={field}>
                <label>{formatField(field)}</label>
                <Input
                  type="text"
                  value={(currentItem && currentItem[field]) || ''}
                  onChange={(e) => handleInputChange(field, e.target.value)}
                />
              </React.Fragment>
            ))}
          </div>
        )}
        {action === 'delete' && <p>Are you sure you want to delete this {title.toLowerCase()}?</p>}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleModalSave}>
          {action === 'edit' && 'Update'}
          {action === 'add' && 'Add'}
          {action === 'delete' && 'Delete'}
        </Button>
        <Button color="secondary" onClick={closeModal}>Cancel</Button>
      </ModalFooter>
    </Modal>
  );
};

export default AdminModal;


// WEBPACK FOOTER //
// ./src/components/common/Tables/AdminModal.jsx